import React from 'react';
import FlowBuilder from '../../../pages/FlowBuilder';

const AIFlowBuilder: React.FC = () => {
  return <FlowBuilder />;
};

export default AIFlowBuilder;